import React, { useEffect, useRef } from 'react'
import { useFormDistribuidor } from '../../hooks/useFormDistribuidores'
import ReCAPTCHA from 'react-google-recaptcha'
import './Distribuidor.css'
// import Spinner from '../../helpers/spinner/spinner'
import { SelectOptionsPaises } from '../../helpers/SelectOptionsPaises/SelectOptionsPaises'
import { MultiCheckboxGroup } from '../../helpers/CheckBox/CheckBox'
import Swal from 'sweetalert2'
import { OptionsFamilias, OptionsTipoCliente } from '../../helpers/SelectOptionsDistributors/SelectOptionsDistribuidores'

const mostrarAlerta = (response) => {
  console.log(response)
  if (response.status === false) {
    Swal
      .fire({
        title: 'Se ha presentado un error',
        text: response.msg,
        icon: 'error',
        confirmButtonText: 'OK',
        allowEscapeKey: false,
        allowEnterKey: false,
        allowOutsideClick: false
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.location.href = '/distribuidor'
        }
      })
  } else if (response.status === true) {
    Swal
      .fire({
        title: 'Se ha enviado el correo correctamente',
        text: response.msg,
        icon: 'success',
        confirmButtonText: 'OK',
        allowEscapeKey: false,
        allowEnterKey: false,
        allowOutsideClick: false
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.location.href = '/distribuidor'
        }
      })
  }
}

const initialForm = {
  nombre: '',
  cargo: '',
  telefono: '',
  email: '',
  empresa: '',
  sitio_web: '',
  pais: '',
  cp: '',
  colonia: '',
  calle: '',
  numero: '',
  ciudad: '',
  estado: '',
  anio_operacion: '',
  rango_empleados: '',
  productos_vendidos: [],
  otrosProductos: '',
  marcas_vendidas: '',
  distribucion_regiones: '',
  infraestructura_logistica: '',
  clientes_objetivo: '',
  canal_ventas: '',
  criterios_proveedor: [],
  captcha: false,
  canal_c: '',
  otros_cc: ''
}

const NAME_PATTERN_STR = '[A-Za-zÁÉÍÓÚÜÑáéíóúüñ ]{2,200}'
const NAME_REGEX = new RegExp('^' + NAME_PATTERN_STR + '$')
const PUESTO_PATTERN_STR = '[A-Za-zÁÉÍÓÚÜÑáéíóúüñ ]{2,100}'
const PUESTO_REGEX = new RegExp('^' + PUESTO_PATTERN_STR + '$')
const PRODUCTOS_PATTERN_STR = '[A-Za-zÁÉÍÓÚÜÑáéíóúüñ ]{5,100}'
const PRODUCTOS_REGEX = new RegExp('^' + PRODUCTOS_PATTERN_STR + '$')
const PHONE_PATTERN = /^(?:\+\d{6,12}|\d{10})$/
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const INFRA = [
  { value: 'almacenes_propios', label: 'Sí, almacenes propios' },
  { value: 'logistica_tercerizada', label: 'Sí, logística tercerizada' },
  { value: 'sin_infraestructura', label: 'No contamos con infraestructura propia' }
]
const CANALES = ['Presencial', 'Online', 'Distribuidor de terceros']
const CRITERIOS_PROVEEDOR = [
  { id: '01', name: 'Precio competitivo' },
  { id: '02', name: 'Calidad de producto' },
  { id: '03', name: 'Tiempo de entrega' },
  { id: '04', name: 'Soporte técnico' },
  { id: '05', name: 'Exclusividad territorial' },
  { id: '06', name: 'Publicidad y material POP' },
  { id: '07', name: 'Garantía/postventa' }
]

const MEDIO_CONOCIMIENTO = [
  { value: 'Facebook', name: 'Facebook' },
  { value: 'Instagram', name: 'Instagram' },
  { value: 'Tik Tok', name: 'Tik Tok' },
  { value: 'Anuncio espectacular/barda', name: 'Anuncio espectacular/barda' },
  { value: 'Sitio web', name: 'Sitio web' },
  { value: 'Otros', name: 'Otros' }
]
const TAMANO_EMPRESA = ['1-10', '11-50', '51-200', '200+']
const CURRENT_YEAR = new Date().getFullYear()

const validationsForm = async (form) => {
  const errors = {}
  let iserror = false

  const nombre = (form.nombre || '').trim()
  const cargoVal = (form.cargo || '').trim()
  const empresaVal = (form.empresa || '').trim()
  const telefonoVal = (form.telefono || '').trim()
  const emailVal = (form.email || '').trim()
  const sitioVal = (form.sitio_web || '').trim()
  const paisVal = (form.pais || '').trim()
  const calleVal = (form.calle || '').trim()
  const numeroVal = (form.numero || '').trim()
  const rangoVal = (form.rango_empleados || '').toString().trim()
  const productos = Array.isArray(form.productos_vendidos) ? form.productos_vendidos : []
  const otros = (form.otrosProductos || '').trim()
  const clienteVal = (form.clientes_objetivo || '').toString().trim()
  const canalVal = (form.canal_ventas || '').toString().trim()
  const criterios = Array.isArray(form.criterios_proveedor) ? form.criterios_proveedor : []
  const infraVal = (form.infraestructura_logistica || '').toString().trim()
  const anioOperacionVal = parseInt((form.anio_operacion || '').trim())
  const coloniaVal = (form.colonia || '').trim()
  const ciudadVal = (form.ciudad || '').trim()
  const estadoVal = (form.estado || '').trim()
  const cpVal = (form.cp || '').trim()
  const marcasVendidasVal = (form.marcas_vendidas || '').trim()
  const distribucionRegionesVal = (form.distribucion_regiones || '').trim()
  const canalC = (form.canal_c || '').trim()
  const otrosCc = (form.otros_cc || '').trim()

  if (!nombre) {
    errors.nombre = 'El campo nombre es requerido'
    iserror = true
  } else if (!NAME_REGEX.test(nombre.trimEnd())) {
    errors.nombre = 'El campo nombre debe de contener solo letras y espacios (2-200).'
    iserror = true
  }

  // Cargo / puesto
  if (!cargoVal) {
    errors.cargo = 'El campo cargo o puesto es requerido.'
    iserror = true
  } else if (!PUESTO_REGEX.test(cargoVal)) {
    errors.cargo = 'El campo cargo o puesto debe de contener solo letras y espacios (2-100).'
    iserror = true
  }

  if (!telefonoVal) {
    errors.telefono = 'El campo teléfono es requerido.'
    iserror = true
  } else if (!PHONE_PATTERN.test(telefonoVal)) {
    errors.telefono = 'El campo teléfono debe ser un número válido (10 dígitos o +código).'
    iserror = true
  }

  if (!emailVal) {
    errors.email = 'El campo correo electrónico es requerido.'
    iserror = true
  } else if (!EMAIL_RE.test(emailVal)) {
    errors.email = 'El correo electrónico no tiene un formato válido.'
    iserror = true
  }

  if (!empresaVal) {
    errors.empresa = 'El campo empresa es requerido.'
    iserror = true
  }

  if (!sitioVal) {
    errors.sitio_web = 'El campo sitio web es requerido.'
    iserror = true
  } else {
    try {
      const url = new URL(sitioVal)
      if (!/^https?:/.test(url.protocol)) {
        errors.sitio_web = 'El sitio web debe utilizar http:// o https://.'
        iserror = true
      }
    } catch (e) {
      errors.sitio_web = 'El sitio web debe ser una URL válida (incluye http:// o https://).'
      iserror = true
    }
  }

  if (!paisVal) {
    errors.pais = 'Selecciona el país.'
    iserror = true
  }

  if (paisVal === 'Mexico') {
    if (!/^\d{5}$/.test(cpVal)) {
      errors.cp = 'El código postal debe tener 5 números para México.'
      iserror = true
    }
  }

  if (!cpVal) {
    errors.cp = 'El codigo postal es requerido.'
    iserror = true
  }

  if (!coloniaVal) {
    errors.colonia = 'La colonia es requerida.'
    iserror = true
  }

  if (!ciudadVal) {
    errors.ciudad = 'La ciudad es requerida.'
    iserror = true
  }
  if (!estadoVal) {
    errors.estado = 'El estado es requerido.'
    iserror = true
  }

  if (!calleVal) {
    errors.calle = 'La calle es requerida.'
    iserror = true
  }

  if (!numeroVal) {
    errors.numero = 'El numero externo es requerido'
    iserror = true
  } else if (numeroVal.length > 20) {
    errors.numero = 'El número es demasiado largo.'
    iserror = true
  }

  if (!anioOperacionVal) {
    errors.anio_operacion = 'El año de inicio de operaciones es requerido'
    iserror = true
  } else if (anioOperacionVal < 1700) {
    errors.anio_operacion = 'El año de inicio de operaciones es incorrecto, debe de ser mayor a 1700'
    iserror = true
  }

  if (!rangoVal) {
    errors.rango_empleados = 'Selecciona el tamaño de la empresa.'
    iserror = true
  }

  // Productos vendidos / otros
  if (productos.length === 0 && !otros) {
    errors.productos_vendidos = 'Indica al menos un tipo de producto o especifica "Otros".'
    iserror = true
  }

  if (otros) {
    if (!PRODUCTOS_REGEX.test(otros)) {
      errors.otrosProductos = 'El campo "Otros" solo puede contener letras y espacios (5-100 caracteres).'
      iserror = true
    }
  }

  if (!marcasVendidasVal) {
    errors.marcas_vendidas = 'Las marcas vendidas son requeridas'
    iserror = true
  }

  if (!distribucionRegionesVal) {
    errors.distribucion_regiones = 'Describa donde tiene presencia comercial'
    iserror = true
  }

  if (!clienteVal) {
    errors.clientes_objetivo = 'Selecciona a qué tipos de clientes vende mayormente.'
    iserror = true
  }

  if (!canalVal) {
    errors.canal_ventas = 'Selecciona el principal canal de ventas.'
    iserror = true
  }

  if (!infraVal) {
    errors.infraestructura_logistica = 'Selecciona si cuentas con infraestructura logística.'
    iserror = true
  }

  if (criterios.length === 0) {
    errors.criterios_proveedor = 'Selecciona al menos un criterio al elegir proveedor.'
    iserror = true
  } else {
    criterios.some((c) => console.log(c))

    const invalid = criterios.some((c) => !CRITERIOS_PROVEEDOR.name === c)
    if (invalid) {
      errors.criterios_proveedor = 'Hay criterios inválidos seleccionados.'
      iserror = true
    }
  }

  if (!canalC) {
    errors.canal_c = 'Este campo es requerido'
    iserror = true
  }

  console.log(canalC)
  if (canalC === 'Otros') {
    if (!otrosCc) {
      errors.otros_cc = 'Este campo es requerido'
      iserror = true
    }
  }

  // Captcha
  if (!form.captcha) {
    errors.captcha = 'Por favor completa el captcha.'
    iserror = true
  }

  return iserror ? errors : null
}

function Distribuidor () {
  const formRef = useRef(null)

  const {
    form,
    errors,
    // loading,
    response,
    col,
    captchaChange,
    handleChange,
    handleSubmit,
    handleInput
  } = useFormDistribuidor(initialForm, validationsForm)

  useEffect(() => {
    document.title = 'Distribuidor' || ' '
  }, [])

  useEffect(() => {
    if (!errors || Object.keys(errors).length === 0) return
    if (!formRef.current) return

    // Toma la primera key de errores(por ej nombre empresa cp)
    const firstErrorKey = Object.keys(errors)[0]

    // Busca el input o select con ese name dentro del form
    const field = formRef.current.querySelector(`[name="${firstErrorKey}"]`)

    if (field) {
      field.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
      field.focus()
    }
  }, [errors])

  return (
    <div
      className='form-container-ditribuidor'
    >
      <form
        id='registro'
        ref={formRef}
        onSubmit={handleSubmit}
        encType='multipart/form-data'
        className='registro-distribuidor'
      >
        <p className='p-introduction' style={{ marginTop: 0 }}>
          Queremos agradecer tu interés en formar parte de nuestra red de distribuidores mayoristas. Te pedimos
          completar el siguiente cuestionario; la Información que nos proporciones nos permitirá comprender mejor tus
          necesidades y expectativas.
        </p>

        <h2 className='solicitud-header'>
          Solicitud de información para Distribuidor
        </h2>

        <h3 className='separador-header'>Datos de contacto</h3>
        <div className='form-grid'>
          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Nombre</b></label>
            <input
              type='text'
              name='nombre'
              maxLength={200}
              pattern={NAME_PATTERN_STR}
              title='Solo letras y espacios, mínimo 2 caracteres.'
              onInput={handleInput}
              onChange={handleChange}
              value={form.nombre}
              className='input-field-distribuidor'
              placeholder='Nombre'
            />
            {errors.nombre && errors.nombre !== '' && (
              <p className='msg-error'>{errors.nombre}</p>
            )}
          </div>
          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Cargo o puesto en la empresa</b></label>
            <input
              type='text'
              name='cargo'
              maxLength={100}
              pattern={PUESTO_PATTERN_STR}
              title='Solo letras y espacios, mínimo 2 caracteres.'
              onInput={handleInput}
              onChange={handleChange}
              value={form.cargo}
              className='input-field-distribuidor'
              placeholder='Cargo o Puesto'
            />
            {errors.cargo && errors.cargo !== '' && (
              <p className='msg-error'>{errors.cargo}</p>
            )}
          </div>
          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Teléfono</b></label>
            <input
              type='tel'
              name='telefono'
              inputMode='tel'
              autoComplete='tel'
              maxLength={13}
              pattern={'^(?:\\+\\d{6,12}|\\d{10})$'}
              onInput={handleInput}
              value={form.telefono}
              onChange={handleChange}
              className='input-field-distribuidor'
              placeholder='Telefono'
            />
            {errors.telefono && errors.telefono !== '' && (
              <p className='msg-error'>{errors.telefono}</p>
            )}
          </div>
          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Correo electrónico</b></label>
            <input
              type='email'
              name='email'
              maxLength={100}
              value={form.email}
              onChange={handleChange}
              className='input-field-distribuidor'
              placeholder='Correo Electrónico'
            />
            {errors.email && errors.email !== '' && (
              <p className='msg-error'>{errors.email}</p>
            )}
          </div>
        </div>

        <h3 className='separador-header'>Información de la empresa</h3>
        <div className='form-grid'>
          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Nombre de la empresa</b></label>
            <input
              type='text'
              name='empresa'
              maxLength={200}
              title='Solo letras y espacios, mínimo 2 caracteres.'
              value={form.empresa}
              onChange={handleChange}
              className='input-field-distribuidor'
              placeholder='Nombre de la Empresa'
            />
            {errors.empresa && errors.empresa !== '' && (
              <p className='msg-error'>{errors.empresa}</p>
            )}
          </div>
          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Sitio web</b></label>
            <input
              type='url'
              name='sitio_web'
              maxLength={100}
              placeholder='https://tu-dominio.com'
              value={form.sitio_web}
              onChange={handleChange}
              className='input-field-distribuidor'
            />
            {errors.sitio_web && errors.sitio_web !== '' && (
              <p className='msg-error'>{errors.sitio_web}</p>
            )}
          </div>
        </div>

        <label><b>Dirección</b></label>
        <div className='form-grid'>
          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>País</b></label>
            <SelectOptionsPaises
              name='pais'
              id='pais'
              optDefault='Selecciona el pais'
              onChange={handleChange}
              className='input-field-distribuidor' />
            {errors.pais && errors.pais !== '' && (
              <p className='msg-error'>{errors.pais}</p>
            )}
          </div>

          <div className='field-block'>
            <label className='etiqueta-distribuidor' htmlFor='cp'><b>Código Postal</b></label>
            <input
              type='text'
              name='cp'
              id='cp'
              onChange={handleChange}
              placeholder={form.pais === 'Mexico' ? 'Código Postal (México)' : 'Código Postal'}
              // pattern={form.pais === 'Mexico' ? '\\d{5}' : undefined}
              maxLength={form.pais === 'Mexico' ? 5 : 20}
              value={form.cp}
              // onBlur={form.pais === 'Mexico' ? handleCpBlur : undefined}
              readOnly={form.pais === ''}
              className='input-field-distribuidor'
            />
            {errors.cp && errors.cp !== '' && (
              <p className='msg-error'>{errors.cp}</p>
            )}
          </div>

          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Colonia</b></label>
            {form.pais === 'Mexico'
              ? (
                <select name='colonia' id='colonia' onChange={handleChange}
                  defaultValue={''}
                  className='input-field-distribuidor' value={form.colonia}>
                  <option
                    key={1}
                    value={''}
                    disabled
                  >
                    Selecciona la colonia
                  </option>
                  {col &&
                    col.map((item, index) => (
                      <option
                        key={index}
                        value={item}
                      >
                        {item}
                      </option>
                    ))}
                </select>
                )
              : (
                <input
                  type='text'
                  name='colonia'
                  id='colonia'
                  placeholder='Barrio / Colonia / Distrito'
                  value={form.colonia}
                  maxLength={100}
                  onChange={handleChange}
                  className='input-field-distribuidor'
                />
                )}
            {errors.colonia && errors.colonia !== '' && (
              <p className='msg-error'>{errors.colonia}</p>
            )}
          </div>

          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Calle</b></label>
            <input
              type='text'
              name='calle'
              maxLength={200}
              className='input-field-distribuidor'
              value={form.Calle}
              onChange={handleChange}
              placeholder='Calle'
            />
            {errors.calle && errors.calle !== '' && (
              <p className='msg-error'>{errors.calle}</p>
            )}
          </div>

          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Número</b></label>
            <input
              type='text'
              name='numero'
              maxLength={20}
              className='input-field-distribuidor'
              placeholder='Numero Exterior'
              value={form.numero}
              onChange={handleChange}
            />
            {errors.numero && errors.numero !== '' && (
              <p className='msg-error'>{errors.numero}</p>
            )}
          </div>

          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Ciudad</b></label>
            <input
              type='text'
              name='ciudad'
              id='ciudad'
              maxLength={100}
              value={form.ciudad}
              readOnly={form.pais === 'Mexico'}
              required={form.pais === 'Mexico'}
              onChange={handleChange}
              className='input-field-distribuidor'
              placeholder='Ciudad'
            />
            {errors.ciudad && errors.ciudad !== '' && (
              <p className='msg-error'>{errors.ciudad}</p>
            )}
          </div>

          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Estado</b></label>
            <input
              type='text'
              name='estado'
              id='estado'
              value={form.estado}
              readOnly={form.pais === 'Mexico'}
              required={form.pais === 'Mexico'}
              onChange={handleChange}
              className='input-field-distribuidor'
              placeholder='Estado'
            />
            {errors.estado && errors.estado !== '' && (
              <p className='msg-error'>{errors.estado}</p>
            )}
          </div>

          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>¿Desde qué año están operando?</b></label>
            <input
              type='number'
              name='anio_operacion'
              min='1900'
              max={CURRENT_YEAR}
              step='1'
              placeholder='Ej. 2005'
              value={form.anio_operacion}
              onChange={handleChange}
              className='input-field-distribuidor'
            />
            {errors.anio_operacion && errors.anio_operacion !== '' && (
              <p className='msg-error'>{errors.anio_operacion}</p>
            )}
          </div>
        </div>

        <div className='form-grid'>
          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>Tamaño de la empresa (empleados)</b></label>
            <select
              id='rango_empleados'
              name='rango_empleados'
              value={form.rango_empleados}
              onChange={handleChange}
              className='input-field-distribuidor'
            >
              <option value=''>Selecciona un rango</option>
              {TAMANO_EMPRESA.map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </select>
            {errors.rango_empleados && errors.rango_empleados !== '' && (
              <p className='msg-error'>{errors.rango_empleados}</p>
            )}
          </div>
        </div>

        <h3 className='separador-header'>Experiencia y enfoque comercial</h3>
        <div className='field-block'>
          <label className='etiqueta-distribuidor'><b>¿Qué tipos de productos comercializa actualmente? (puede seleccionar varios)</b></label>
          <div className='box-list'>
          <OptionsFamilias handleChange={handleChange} handleInput={handleInput} value={form.productos_vendidos}/>
          </div>
          {errors.productos_vendidos && errors.productos_vendidos !== '' && (
            <p className='msg-error'>{errors.productos_vendidos}</p>
          )}
          {errors.otrosProductos && errors.otrosProductos !== '' && (
            <p className='msg-error'>{errors.otrosProductos}</p>
          )}
        </div>

        <div className='form-grid'>
          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>¿Cuáles son las marcas que actualmente representa?</b></label>
            <textarea
              name='marcas_vendidas'
              placeholder=''
              value={form.marcas_vendidas}
              onChange={handleChange}
              className='input-field-distribuidor text-area'
            />
            {errors.marcas_vendidas && errors.marcas_vendidas !== '' && (
              <p className='msg-error'>{errors.marcas_vendidas}</p>
            )}
          </div>
        </div>

        <h3 className='separador-header'>Cobertura y logística</h3>
        <div className='form-grid'>
          <div className='field-block'>
            <label className='etiqueta-distribuidor'><b>¿En qué regiones o estados tiene presencia comercial?</b></label>
            <textarea
              name='distribucion_regiones'
              value={form.distribucion_regiones}
              onChange={handleChange}
              className='input-field-distribuidor text-area' />
            {errors.distribucion_regiones && errors.distribucion_regiones !== '' && (
              <p className='msg-error'>{errors.distribucion_regiones}</p>
            )}
          </div>
        </div>

        <div className='field-block'>
          <label className='etiqueta-distribuidor'><b>¿Cuenta con infraestructura propia de almacenamiento y logística?</b></label>
          <div className='box-list'>
            {INFRA.map((o) => (
              <label key={'inf-' + o.value}>
                <input
                  type='radio'
                  name='infraestructura_logistica'
                  value={o.value}
                  onChange={handleChange}
                />
                {o.label}
              </label>
            ))}
          </div>
          {errors.infraestructura_logistica && errors.infraestructura_logistica !== '' && (
            <p className='msg-error'>{errors.infraestructura_logistica}</p>
          )}
        </div>

        <h3 className='separador-header'>Canales de venta</h3>
        <div className='field-block'>
          <label className='etiqueta-distribuidor'><b>¿A qué tipos de clientes vende mayormente?</b></label>
          <OptionsTipoCliente handleChange={handleChange} selectedOption={form.clientes_objetivo} />
          {errors.clientes_objetivo && errors.clientes_objetivo !== '' && (
            <p className='msg-error'>{errors.clientes_objetivo}</p>
          )}
        </div>

        <div className='field-block'>
          <label className='etiqueta-distribuidor'><b>¿Cuál es tu principal canal de ventas?</b></label>
          <div className='box-list'>
            {CANALES.map((c) => (
              <label key={'can-' + c}>
                <input
                  type='radio'
                  name='canal_ventas'
                  value={c}
                  onChange={handleChange}
                />
                {c}
              </label>
            ))}
          </div>
          {errors.canal_ventas && errors.canal_ventas !== '' && (
            <p className='msg-error'>{errors.canal_ventas}</p>
          )}
        </div>

        <h3 className='separador-header'>Potencial colaboración</h3>
        <div className='field-block'>
          <label className='etiqueta-distribuidor'><b>¿Cuáles son los principales criterios al seleccionar un nuevo proveedor? (puede seleccionar varios)</b></label>
          <div className='box-list'>
            <MultiCheckboxGroup
              name={'criterios_proveedor'}
              options={CRITERIOS_PROVEEDOR}
              selectedValues={form.criterios_proveedor}
              onChange={handleChange}
              className='input-field-distribuidor' />
          </div>
          {errors.criterios_proveedor && errors.criterios_proveedor !== '' && (
            <p className='msg-error'>{errors.criterios_proveedor}</p>
          )}
        </div>

        <div className='field-block'>
          <label className='etiqueta-distribuidor'><b>Como te enteraste de nuestras marcas</b></label>
          <select
            id='canal_c'
            name='canal_c'
            value={form.canal_c}
            onChange={handleChange}
            className='input-field-distribuidor'
          >
            <option value=''>Selecciona un el medio donde te enteraste de nosotros</option>
            {MEDIO_CONOCIMIENTO.map((r) => (
              <option key={r.value} value={r.value}>
                {r.name}
              </option>
            ))}
          </select>
          {form.canal_c === 'Otros'
            ? <input
              type='text'
              maxLength={50}
              placeholder='Otros (especifica)'
              name='otros_cc'
              onChange={handleChange}
              value={form.otros_cc}
              className='input-field-distribuidor'
            />
            : <></>}
          {errors.canal_c && errors.canal_c !== '' && (
            <p className='msg-error'>{errors.canal_c}</p>
          )}
          {errors.otros_cc && errors.otros_cc !== '' && (
            <p className='msg-error'>{errors.otros_cc}</p>
          )}
        </div>

        <div className='form-grid'>
          <div className='field-block'>
            <ReCAPTCHA
              name='captcha'
              sitekey='6LeX4K0gAAAAADk_Kj6wiwPFKIpAywdjX-TW3Ygg'
              onChange={captchaChange}
              className='g-recaptcha'
            />
            {errors.captcha && errors.captcha !== '' && (
              <p className='msg-error'>{errors.captcha}</p>
            )}
          </div>
        </div>

        <button type='submit' className='submit-frm-dist'>Enviar</button>

        <p style={{ marginTop: 16 }}>
          Agradecemos el tiempo dedicado a completar este cuestionario y quedamos atentos para continuar esta conversación. Atte.
          Industrias Macon.
        </p>
      </form>
      {response && mostrarAlerta(response)}
    </div>
  )
}

export default Distribuidor
